<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <DataTable :value="panchayatsamitilist" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    data-key="mbe1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Panchayat Samiti</h5>
                        </template>
                        <template v-slot:right>
                            <!-- <Button label="Import" icon="pi pi-paperclip" class="p-mr-2"
                                @click="onImportPanchayatSamiti" /> -->
                            <Button label="Add Panchayat Samiti" icon="pi pi-plus" class=" p-mr-2"
                                @click="addPanchayatSamitiDialogOpen" />
                                <Button v-if="!showFillFilter" label="Filter" icon="pi pi-filter" @click="filterlisting()"></Button>
                            <Button v-if="showFillFilter" label="Filter" icon="pi pi-filter-slash" class="p-button-success" @click="filterlisting()"></Button>
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data Please wait... </template>
                    <Column header="Sr." headerStyle="width: 4%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Panchayat Samiti" headerStyle="width: 18%">
                        <template #body="{data}">
                            <div class="p-text-capitalize">{{ data.mbe15 ? data.mbe15 : 'N/A' }}</div>
                        </template>
                    </Column>
                    <Column header="Zilla Parishad" headerStyle="width: 17%">
                        <template #body="{data}">
                            <div>
                                <div class="p-text-capitalize"><span v-tooltip.right="'Vidhan Sabha'">{{ data.mbe4 ? data.mbe4 : 'N/A' }}</span></div>
                                <div class="p-text-capitalize p-mt-1"><small class="muted-text"
                                        v-tooltip.right="'Zilla Parishad'">{{ data.mbe6 ? data.mbe6 : 'N/A' }}</small></div>
                            </div>
                        </template>
                    </Column>
                    <Column header="State" headerStyle="width: 17%">
                        <template #body="{data}">
                            <div class="p-text-capitalize">{{ data.mbe10 ? data.mbe10 : 'N/A' }}</div>
                        </template>
                    </Column>
                    <Column header="District" headerStyle="width: 17%">
                        <template #body="{data}">
                            <div class="p-text-capitalize">{{ data.mbe12 ? data.mbe12 : 'N/A' }}</div>
                        </template>
                    </Column>
                    <Column header="Taluka" headerStyle="width: 17%">
                        <template #body="{data}">
                            <div class="p-text-capitalize">{{ data.mbe14 ? data.mbe14 : 'N/A' }}</div>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 10%" class="p-text-center">
                        <template #body="{data}">
                            <Button icon="pi pi-pencil" class="p-button-rounded "
                                @click="editPanchayatSamitiDialogOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </div>
    </div>
    <!-- add Panchayat Samiti dialog start here -->
    <Dialog v-model:visible="addPanchayatSamitiStatus" :style="{ width: '800px' }" header="Add Panchayat Samiti"
        :modal="true" class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="state">
                        State
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="state" v-model="state" :options="stateList" @change="getdistrictName($event)" optionLabel="label"
                        placeholder="Select ..." autofocus :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.state.$error">{{
                    v$.state.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="district">
                        District
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="district" v-model="district" @change="getvishansabhaName($event)" :options="districtList" optionLabel="label"
                        placeholder="Select ..." :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.district.$error">{{
                    v$.district.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="vidhansabha">
                        Vidhan Sabha
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="vidhansabha" v-model="vidhansabha" @change="getzillaparishadName($event)" :options="vidhansabhaList" optionLabel="label"
                        placeholder="Select ..." :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.vidhansabha.$error">{{
                    v$.vidhansabha.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="zillaparishad">
                        Zilla Parishad
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="zillaparishad" v-model="zillaparishad" :options="zillaparishadList"
                        optionLabel="label" placeholder="Select ..." :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.zillaparishad.$error">{{
                    v$.zillaparishad.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6" v-show="!isTalukaNameExist">
                    <label for="taluka">
                        Taluka Name
                        <b class="p-error">*</b>
                    </label>
                    <AutoComplete forceSelection id="taluka" placeholder="Search..."
                        :dropdown="false" :multiple="false" v-model="taluka" :suggestions="talukaList"
                        @complete="getTalukaName($event)" field="label" class="p-text-capitalize" autofocus
                        :class="{ 'p-invalid': submitted && !taluka }" />
                    <small class="p-invalid p-error" v-if="v$.taluka.$error">{{ v$.taluka.$errors[0].$message }}</small>
                    <label class="p-mt-1" v-if="openStatus == 1">
                        Not found,
                        <span>
                            <a class="p-ai-center p-text-right" style="color: #3f51b5" @click="toggleTalukaname">Click here for create</a>
                        </span>
                    </label>
                </div>
                <div class="p-field p-col-12 p-md-6" v-show="isTalukaNameExist">
                    <label for="taluka">
                        Create Taluka
                        <b class="p-error">*</b>
                    </label>
                    <InputText class="p-text-capitalize" placeholder="Enter Taluka name" @input="createTalukaName" maxlength="50" autofocus
                        :class="{ 'p-invalid': submitted && !taluka }" />
                    <label class="p-mt-1">
                        For search,
                        <span>
                            <a class="p-ai-center p-text-right" style="color: #3f51b5" @click="toggleTalukaname">Click here</a>
                        </span>
                    </label>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="panchayatsamitiname">
                        Panchayat Samiti Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="panchayatsamitiname" class="p-text-capitalize" v-model.trim="panchayatsamitiname"
                        required="true" autofocus
                        :class="{ 'p-invalid': submitted && !panchayatsamitiname }" />
                    <small class="p-invalid p-error" v-if="v$.panchayatsamitiname.$error">{{
                            v$.panchayatsamitiname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="reservationvalue">
                        Reservation Seats
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="reservationvalue" v-model="reservationvalue" :options="reservationList"
                        optionLabel="label" placeholder="Select ..." :filter="false" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.reservationvalue.$error">{{
                    v$.reservationvalue.$errors[0].$message
                    }}</small>
                </div>
            </div>
        </div>
        <template #footer>
            <div>
                <Button v-if="!showLoader" label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto"
                    @click="addPanchayatSamiti" style="width: 90px"></Button>
                <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                    style="width: 90px"></Button>
            </div>
        </template>
    </Dialog>
    <!-- add Panchayat Samiti dialog end here -->
    <!-- edit Panchayat Samiti dialog start here -->
    <Dialog v-model:visible="editPanchayatSamitiStatus" :style="{ width: '800px' }" header="Edit Panchayat Samiti"
        :modal="true" class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="state">
                        State
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="state" v-model="state" :options="stateList" @change="getdistrictName($event)" optionLabel="label"
                        placeholder="Select ..." autofocus :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.state.$error">{{
                    v$.state.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="district">
                        District
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="district" v-model="district" @change="getvishansabhaName($event)" :options="districtList" optionLabel="label"
                        placeholder="Select ..." :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.district.$error">{{
                    v$.district.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="vidhansabha">
                        Vidhan Sabha
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="vidhansabha" v-model="vidhansabha" @change="getzillaparishadName($event)" :options="vidhansabhaList" optionLabel="label"
                        placeholder="Select ..." :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.vidhansabha.$error">{{
                    v$.vidhansabha.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="zillaparishad">
                        Zilla Parishad
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="zillaparishad" v-model="zillaparishad" :options="zillaparishadList"
                        optionLabel="label" placeholder="Select ..." :filter="true" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.zillaparishad.$error">{{
                    v$.zillaparishad.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6" v-show="!isTalukaNameExist">
                    <label for="taluka">
                        Taluka Name
                        <b class="p-error">*</b>
                    </label>
                    <AutoComplete forceSelection id="taluka" placeholder="Search..."
                        :dropdown="false" :multiple="false" v-model="taluka" :suggestions="talukaList"
                        @complete="getTalukaName($event)" field="label" class="p-text-capitalize" autofocus
                        :class="{ 'p-invalid': submitted && !taluka }" />
                    <small class="p-invalid p-error" v-if="v$.taluka.$error">{{ v$.taluka.$errors[0].$message }}</small>
                    <label class="p-mt-1" v-if="openStatus == 1">
                        Not found,
                        <span>
                            <a class="p-ai-center p-text-right" style="color: #3f51b5" @click="toggleTalukaname">Click here for create</a>
                        </span>
                    </label>
                </div>
                <div class="p-field p-col-12 p-md-6" v-show="isTalukaNameExist">
                    <label for="taluka">
                        Create Taluka
                        <b class="p-error">*</b>
                    </label>
                    <InputText class="p-text-capitalize" placeholder="Enter Taluka name" @input="createTalukaName" maxlength="50" autofocus
                        :class="{ 'p-invalid': submitted && !taluka }" />
                    <label class="p-mt-1">
                        For search,
                        <span>
                            <a class="p-ai-center p-text-right" style="color: #3f51b5" @click="toggleTalukaname">Click here</a>
                        </span>
                    </label>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="panchayatsamitiname">
                        Panchayat Samiti Name
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <InputText id="panchayatsamitiname" class="p-text-capitalize" v-model.trim="panchayatsamitiname"
                        required="true" autofocus
                        :class="{ 'p-invalid': submitted && !panchayatsamitiname }" />
                    <small class="p-invalid p-error" v-if="v$.panchayatsamitiname.$error">{{
                            v$.panchayatsamitiname.$errors[0].$message
                    }}</small>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="reservationvalue">
                        Reservation Seats
                        <span class="p-invalid p-error">*</span>
                    </label>
                    <Dropdown id="reservationvalue" v-model="reservationvalue" :options="reservationList"
                        optionLabel="label" placeholder="Select ..." :filter="false" appendTo="body"></Dropdown>
                    <small class="p-invalid p-error" v-if="v$.reservationvalue.$error">{{
                    v$.reservationvalue.$errors[0].$message
                    }}</small>
                </div>
            </div>
        </div>
        <template #footer>
            <div>
                <Button v-if="!showLoader" label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto"
                    @click="updatePanchayatSamiti" style="width: 90px"></Button>
                <Button v-show="showLoader" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                    style="width: 90px"></Button>
            </div>
        </template>
    </Dialog>
    <!-- edit Panchayat Samiti dialog end here -->
    <!----Start of filter--------------------------------->
    <Dialog v-model:visible="filterListingDialog" :style="{ width: '800px' }" header="Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                    <label for="state">State</label>
                    <MultiSelect v-model="state_fks" :options="stateList" optionValue="value" optionLabel="label"
                        placeholder="Select" :filter="true" class="multiselect-custom" appendTo="body"></MultiSelect>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="loksabhaname">District</label>
                    <MultiSelect v-model="district_fks" :options="districtList" optionValue="value" optionLabel="label"
                        placeholder="Select" :filter="true" class="multiselect-custom" appendTo="body"></MultiSelect>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="vidhansabhaname">Vidhan Sabha</label>
                    <MultiSelect v-model="vidhansabha_fks" :options="vidhansabhaList" optionValue="value"
                        optionLabel="label" placeholder="Select" :filter="true" class="multiselect-custom"
                        appendTo="body"></MultiSelect>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="zillaparishadname">Zilla Parishad</label>
                    <MultiSelect v-model="zillaparishad_fks" :options="zillaparishadList" optionValue="value" optionLabel="label"
                        placeholder="Select" :filter="true" class="multiselect-custom" appendTo="body"></MultiSelect>
                </div>
                <div class="p-field p-col-12 p-md-6">
                    <label for="zillaparishadname">Panchayat Samiti</label>
                    <MultiSelect v-model="panchayat_fks" :options="panchayatList" optionValue="value" optionLabel="label"
                        placeholder="Select" :filter="true" class="multiselect-custom" appendTo="body"></MultiSelect>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus
                @click="getFilteredData(state_fks, zillaparishad_fks, district_fks, vidhansabha_fks, panchayat_fks)" />
        </template>
    </Dialog>
    <!----End of filter--------------------------------->

    <!-- import csv dialog start here -->
    <Dialog v-model:visible="isImportPanchayatSamiti" :style="{ width: '1100px' }" header="Import Panchayat Samiti" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6" align="left">
                    <FileUpload mode="basic" name="demo[]" url="./upload" accept="text/csv" :maxFileSize="1000000" @upload="onUpload" />
                </div>
                <div class="p-field p-col-12 p-md-6" align="right">
                        <label class="p-mr-2">
                            Download Sample Sheet:
                        </label>
                        <!-- TODO: Need CSV File URL here -->
                        <router-link href="replace-csv-string" target="_blank" to="#">
                            <Button icon="pi pi-download" v-tooltip.left="'Download Sample Sheet'" class="p-button-rounded">
                            </Button>
                        </router-link>
                </div>
                <div class="p-field p-col-12">
                    <h5 class="indigo-color p-m-0 p-pl-1">Note:</h5>
                    <ol style="line-height: 1.5;">
                        <li>The file name should be same as sample file name "import_open_enquiries.csv".</li>
                        <li>Do not just change any files extension from .XLS or any other extension to CSV and upload it.</li>
                        <li>You can upload enquiries in one sheet up to 5000 enquiries in one attempt.</li>
                        <li>Don't change and delete any column name in CSV sheet.</li>
                        <li>Date format must be in "dd-mm-yyyy".</li>
                        <li>Insert employee mobile number properly to allocate the enquiry to a particular employee, else enquiry will be inserted into logged-in employees Lok-neta account.</li>
                        <li>Project name, unit type & source must be the same as in the Lok-neta System.</li>
                        <li>In CSV sheet enquiry date, first name or last name, mobile or email, employee mobile, source column's are mandatory.</li>
                        <li>Submitted sheets for importing enquiries till 10 pm will be executed on the same night and the result will be available by 7 am next day</li>
                    </ol>
                </div>
            </div>
        </div>
        <template #footer>
                <Button label="Submit" icon="pi pi-check" class="p-button-text"
                @click="onSubmit" />
        </template>
    </Dialog>
    <!-- import dialog end here -->
</template>
<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
export default {
    data() {
        return {
            v$: useValidate(),
            panchayatsamitilist: [],
            page_no: 0,
            totalRecords: 0,
            loading: false,
            addPanchayatSamitiStatus: false,
            editPanchayatSamitiStatus: false,
            state: '',
            stateList: [],
            district: '',
            districtList: [],
            vidhansabha: '',
            vidhansabhaList: [],
            zillaparishad: '',
            zillaparishadList: [],
            taluka: '',
            talukaList: [],
            reservationvalue: '',
            reservationList: [],
            showLoader: false,
            submitted: false,
            isTalukaNameExist: false,
            taluka_status: '',
            openStatus: 0,
            panchayatsamitiname: '',
            row_id: null,
            filterListingDialog: false,
            state_fks: [],
            zillaparishad_fks: [],
            district_fks: [],
            vidhansabha_fks: [],
            constitencytype_fk: [],
            panchayat_fks: [],
            panchayatList: [],
            showFillFilter: false,
            isImportPanchayatSamiti: false,
        };
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.loading = true;
        this.getpanchayatsamitilist();
        this.getReservations();
        // this.getvidhansabha();
        // this.getzillaparishad();
        // this.gettaluka();
        this.getStates();
    },
    validations() {
        return {
            state: { required: helpers.withMessage('Please select state', required) },
            district: { required: helpers.withMessage('Please select district', required) },
            vidhansabha: { required: helpers.withMessage('Please select vidhan sabha', required) },
            zillaparishad: { required: helpers.withMessage('Please select zilla parishad', required) },
            taluka: { required: helpers.withMessage('Please select taluka', required) },
            reservationvalue: { required: helpers.withMessage('Please select reservation', required) },
            panchayatsamitiname: { required: helpers.withMessage('Please enter panchayatsamiti name', required) }
        };
    },
    methods: {
        onImportPanchayatSamiti() {
            this.isImportPanchayatSamiti = true;
        },
        // gettaluka(ev) {
        //     this.ApiService.gettaluka(ev).then((data) => {
        //         if (data.status == 200) {
        //             this.talukaList = data.data;
        //         } else {
        //             this.talukaList = '';
        //         }
        //     });
        // },
        getdistrictName(e) {
            this.vidhansabha = '';
            this.zillaparishad = '';
            this.taluka = '';
            this.panchayatsamitiname = '';
            if (e.value) {
                this.ApiService.getdistrict({ state_id: e.value.value }).then((items) => {
                    if (items.success === true) {
                        this.districtList = items.data;
                    }
                });
            }
        },
        getvishansabhaName(e) {
            this.zillaparishad = '';
            this.taluka = '';
            this.panchayatsamitiname = '';
            if (e.value) {
                this.ApiService.getvidhansabha({ district_id: e.value.value }).then((items) => {
                    if (items.success === true) {
                        this.vidhansabhaList = items.data;
                    }
                });
            }
        },
        getzillaparishadName(e) {
            this.taluka = '';
            this.panchayatsamitiname = '';
            if (e.value) {
                this.ApiService.getzillaparishad({ vidhansabha_id: e.value.value }).then((items) => {
                    if (items.success === true) {
                        this.zillaparishadList = items.data;
                    }
                });
            }
        },
        getStates(ev) {
            this.ApiService.getStates(ev).then((data) => {
                if (data.status == 200) {
                    this.stateList = data.data;
                } else {
                    this.stateList = '';
                }
            });
        },
        // getzillaparishad(ev) {
        //     this.ApiService.getzillaparishad(ev).then((data) => {
        //         if (data.status == 200) {
        //             this.zillaparishadList = data.data;
        //         } else {
        //             this.zillaparishadList = '';
        //         }
        //     });
        // },
        // getvidhansabha(ev) {
        //     this.ApiService.getvidhansabha(ev).then((data) => {
        //         if (data.status == 200) {
        //             this.vidhansabhaList = data.data;
        //         } else {
        //             this.vidhansabhaList = '';
        //         }
        //     });
        // },
        getReservations(ev) {
            this.ApiService.getReservations(ev).then((data) => {
                if (data.status == 200) {
                    this.reservationList = data.data;
                } else {
                    this.reservationList = '';
                }
            });
        },
        getpanchayatsamitilist(ev) {
            this.loading = true;
            this.ApiService.getpanchayatsamitilist(ev).then((data) => {
                if (data.status == 200) {
                    this.panchayatsamitilist = data.data.result;
                    this.totalRecords = data.data.count;
                } else {
                    this.panchayatsamitilist = '';
                    this.totalRecords = 0;
                }
                this.loading = false;
            });
        },
        getTalukaName(e) {
            if (e.query.length > 1) {
                this.ApiService.gettaluka({ company: e.query }).then((data) => {
                    if (data.status === 200) {
                        this.talukaList = data.data;
                    }
                    if (data.status === 201) {
                        this.openStatus = 1;
                        this.talukaList = [];
                    }
                });
            }
        },
        toggleTalukaname() {
            this.isTalukaNameExist = !this.isTalukaNameExist;
            this.taluka = '';
        },
        createTalukaName(e) {
            if (e) {
                this.taluka = { value: 0, label: e.target.value, ea12: '', ea16: '' };
                this.tea5 = e.target.value;
                this.taluka_status = '';
            } else {
                this.taluka = '';
                this.tea5 = '';
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getpanchayatsamitilist({ 
                page_no: event.page,
                statefilter: this.event_state,
                zillaparishadfilter: this.event_zillaparishad,
                districtfilter: this.event_district,
                vidhansabhafilter: this.event_vidhansabha,
                panchayatfilter: this.event_panchayat,
             });
        },
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },
        addPanchayatSamitiDialogOpen() {
            this.addPanchayatSamitiStatus = true;
            this.submitted = false;
            this.state = '';
            this.district = '';
            this.vidhansabha = '';
            this.zillaparishad = '';
            this.taluka = '';
            this.reservationvalue = '';
            this.panchayatsamitiname = '';
        },
        editPanchayatSamitiDialogOpen(e) {
            this.editPanchayatSamitiStatus = true;
            this.submitted = false;
            this.row_id = e.mbe1;
            
            let mbe10 = this.stateList.find(function (item) {
                return item.value == e.mbe10;
            });
            if (mbe10.length > 0) {
                this.state = mbe10;
            }
            let mbe12 = this.districtList.find(function (item) {
                return item.value == e.mbe12;
            });
            if (mbe12.length > 0) {
                this.district = mbe12;
            }
            let mbe3 = this.vidhansabhaList.filter(function (item) {
                return item.value == e.mbe3;
            });
            if (mbe3.length > 0) {
                this.vidhansabha = mbe3[0];
            }
            let mbe5 = this.zillaparishadList.filter(function (item) {
                return item.value == e.mbe5;
            });
            if (mbe5.length > 0) {
                this.zillaparishad = mbe5[0];
            }
            // let mbe13 = this.talukaList.filter(function (item) {
            //     return item.value == e.mbe13;
            // });
            // if (mbe13.length > 0) {
            //     this.taluka = mbe13[0];
            // }
            this.panchayatsamitiname = e.mbe15;
            let mbe7 = this.reservationList.filter(function (item) {
                return item.value == e.mbe7;
            });
            if (mbe7.length > 0) {
                this.reservationvalue = mbe7[0];
            }
        },
        addPanchayatSamiti() {
            this.submitted = true;
            this.errormsg = '';
            let fields = {};
            fields['mbe9'] = this.state.value;
            fields['mbe10'] = this.state.label;
            fields['mbe11'] = this.district.value;
            fields['mbe12'] = this.district.label;
            fields['mbe3'] = this.vidhansabha.value;
            fields['mbe4'] = this.vidhansabha.label;
            fields['mbe5'] = this.zillaparishad.value;
            fields['mbe6'] = this.zillaparishad.label;
            fields['mbe13'] = this.taluka.value;
            fields['mbe14'] = this.taluka.label;
            fields['mbe15'] = this.panchayatsamitiname;
            fields['mbe7'] = this.reservationvalue.value;
            fields['mbe8'] = this.reservationvalue.label;
            this.v$.$validate();
            if (!this.v$.$error) {
                this.loading = true;
                this.showLoader = true;
                this.ApiService.createpanchayatsamiti(fields).then((items) => {
                    if (items.status == 200) {
                        this.loading = false;
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.addPanchayatSamitiStatus = false;
                        this.isTalukaNameExist = false;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.state = '';
                        this.district = '';
                        this.vidhansabha = '';
                        this.zillaparishad = '';
                        this.taluka = '';
                        this.reservationvalue = '';
                        this.panchayatsamitiname = '';
                        this.getpanchayatsamitilist();
                    } else {
                        this.loading = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        updatePanchayatSamiti() {
            this.submitted = true;
            this.errormsg = '';
            let fields = {};
            fields['mbe1'] = this.row_id;
            fields['mbe9'] = this.state.value;
            fields['mbe10'] = this.state.label;
            fields['mbe11'] = this.district.value;
            fields['mbe12'] = this.district.label;
            fields['mbe3'] = this.vidhansabha.value;
            fields['mbe4'] = this.vidhansabha.label;
            fields['mbe5'] = this.zillaparishad.value;
            fields['mbe6'] = this.zillaparishad.label;
            fields['mbe13'] = this.taluka.value;
            fields['mbe14'] = this.taluka.label;
            fields['mbe15'] = this.panchayatsamitiname;
            fields['mbe7'] = this.reservationvalue.value;
            fields['mbe8'] = this.reservationvalue.label;
            this.v$.$validate();
            if (!this.v$.$error) {
                this.loading = true;
                this.showLoader = true;
                this.ApiService.createpanchayatsamiti(fields).then((items) => {
                    if (items.status == 200) {
                        this.loading = false;
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.editPanchayatSamitiStatus = false;
                        this.isTalukaNameExist = false;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        setTimeout(() => {
                            this.v$.$reset();
                        }, 0);
                        this.getpanchayatsamitilist();
                    } else {
                        this.loading = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        filterlisting() {
            this.filterListingDialog = true;
            this.getVidhansabhaFilter();
            this.getStatesFilter();
            this.getDistrictFilter();
            this.getZillaparishadFilter();
            this.getPanchayatSamitiFilter();
        },
        getFilteredData(event_state, event_zillaparishad, event_district, event_vidhansabha, event_panchayat) {
            this.loading = true;
            this.state_fks = event_state;
            this.zillaparishad_fks = event_zillaparishad;
            this.district_fks = event_district;
            this.vidhansabha_fks = event_vidhansabha;
            this.panchayat_fks = event_panchayat;
            this.getpanchayatsamitilist({
                statefilter: this.state_fks,
                zillaparishadfilter: this.zillaparishad_fks,
                districtfilter: this.district_fks,
                vidhansabhafilter: this.vidhansabha_fks,
                panchayatfilter: this.panchayat_fks,
            });
            this.showFillFilter = true;
            this.filterListingDialog = false;
        },
        reSetFilteredData() {
            this.state_fks = "";
            this.zillaparishad_fks = '';
            this.district_fks = '';
            this.vidhansabha_fks = '';
            this.panchayat_fks = '';
            this.getpanchayatsamitilist();
            this.showFillFilter = false;
            this.filterListingDialog = false;
        },
        getVidhansabhaFilter(ev) {
            this.ApiService.getvidhansabha(ev).then((data) => {
                if (data.status == 200) {
                    this.vidhansabhaList = data.data;
                } else {
                    this.vidhansabhaList = '';
                }
            });
        },
        getStatesFilter(ev) {
            this.ApiService.getStates(ev).then((data) => {
                if (data.status == 200) {
                    this.stateList = data.data;
                } else {
                    this.stateList = '';
                }
            });
        },
        getDistrictFilter(ev) {
            this.ApiService.getdistrict(ev).then((items) => {
                if (items.success === true) {
                    this.districtList = items.data;
                } else {
                    this.districtList = '';
                }
            });
        },
        getZillaparishadFilter(ev) {
            this.ApiService.getzillaparishad(ev).then((items) => {
                if (items.success === true) {
                    this.zillaparishadList = items.data;
                } else {
                    this.zillaparishadList = '';
                }
            });
        },
        getPanchayatSamitiFilter(ev) {
            this.ApiService.getpanchayatsamiti(ev).then((data) => {
                if (data.status == 200) {
                    this.panchayatList = data.data;
                } else {
                    this.panchayatList = '';
                }
            });
        },
    },
};
</script>
<style scoped lang="scss">
.user-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-active {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-per-suspend {
        background: #ffcdd2;
        color: #c63737;
    }

    &.status-temp-suspend {
        background: #ffd8b2;
        color: #805b36;
    }
}
</style>
